function addAgeSuitability({ userId, metadataId, min }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/ageSuitabilities`;
  return apiClient.post(route, { userId, metadataId, min });
}

function updateAgeSuitability({ userId, ageSuitabilityId, min }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/ageSuitabilities/${ageSuitabilityId}`;
  return apiClient.patch(route, { userId, min });
}

function removeAgeSuitability({ userId, ageSuitabilityId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/ageSuitabilities/${ageSuitabilityId}`;
  return apiClient.delete(route, { userId });
}

export default {
  addAgeSuitability,
  updateAgeSuitability,
  removeAgeSuitability
};
